import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'tenant-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  imports: [RouterLink],
  standalone: true,
})
export class PageNotFoundComponent {}
